import React, {memo} from 'react';

type CompareFunctions = ((x: any) => any)[];

const compareFunc = (...compareFunctions: CompareFunctions) =>
  (prevProps: React.ComponentProps<any>, nextProps: React.ComponentProps<any>) => {
    for (let compareFuncIndex = 0; compareFuncIndex < compareFunctions.length; compareFuncIndex++) {
      const compareFunc = compareFunctions[compareFuncIndex];
      if (compareFunc(prevProps) !== compareFunc(nextProps)) return false;
    }
    return true;
  };

const selectiveMemoComparison = (Component: React.ComponentProps<any>) =>
  (...compareFunctions: CompareFunctions) => memo(Component, compareFunc(...compareFunctions));

export default selectiveMemoComparison;



